// noinspection DuplicatedCode
import React, { useEffect, useState } from "react";
import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost, fetchPut } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import DynamicTableSimpleCustom from "../../../components/tablecard/DynamicTableSimpleCustom";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const UpdateKendaraanPage = ({}) => {
  let initialState = {
    BisnisUnitID: "",
    Tanggal: new Date(),
    PurchaseOrderID: "",
    KendaraanID: "CS001",
    GeneralServiceUnit: "",
    Keterangan: "",
  };

  let initialStateModal = {
    Nik: "",
    Nama: "",
    ActivityID: "",
    ActivityNama: "",
    JenisPetugas: "",
    HasilKerja: "",
    Satuan: "",
    JamAwal: "",
    JamAkhir: "",
    KMHMAwal: "",
    KMHMAkhir: "",
    BBM: "",
    KeteranganDetail: "",
  };

  const [karyawanList, setKaryawanList] = useState([]);
  const [activityList, setActivityList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { values, touched, customHandler, changeHandler, errors, blastChange } =
    useForm(initialState, []);

  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalDetail, setModalDetail] = useState(initialStateModal);
  const [modalID, setModalID] = useState(0);

  const ModalOpener = () => {
    // Tunggu sampai dropdown data siap
    if (karyawanList.length === 0 || activityList.length === 0) {
      alert("Sedang memuat data dropdown... Silakan tunggu sebentar.");
      return;
    }

    setModalDetail(initialStateModal);
    setShowModal(true);
    setShowModalEdit(false);
  };

  const params = useParams();
  const navigate = useNavigate();

  // Mutations
  const mutationAdd = useMutation((formData) =>
    fetchPost("Procurement/Kendaraan", formData)
  );
  const mutationGet = useMutation(() =>
    fetchGet(`Procurement/Kendaraan/byId/${params.id}`)
  );
  const mutationUpdate = useMutation((formData) =>
    fetchPut("Procurement/Kendaraan", formData)
  );

  // Fetch data untuk dropdown
  const fetchKaryawan = useMutation(() => fetchPost("getKaryawanMinV2", {}));
  const fetchActivity = useMutation(() => fetchGet("Master/Activity/min"));

  // Load data saat komponen mount
  useEffect(() => {
    setIsLoading(true);

    // Fetch dropdown data
    fetchKaryawan.mutate();
    fetchActivity.mutate();

    if (params.id) {
      mutationGet.mutate();
    } else {
      setIsLoading(false);
    }
  }, [params.id]);

  // Simpan data ke state
  useEffect(() => {
    if (fetchKaryawan.data?.data) {
      setKaryawanList(fetchKaryawan.data.data);
    }
  }, [fetchKaryawan.data]);

  useEffect(() => {
    if (fetchActivity.data?.data) {
      setActivityList(fetchActivity.data.data);
    }
  }, [fetchActivity.data]);

  // GANTI useEffect yang ini dengan versi yang diperbaiki:
  useEffect(() => {
    if (mutationGet.data?.data) {
      const data = mutationGet.data.data;
      console.log("======== API RESPONSE DATA ========", data);

      // DEBUG: Tampilkan KendaraanListID dari API
      if (data.Data && Array.isArray(data.Data)) {
        console.log(
          "KendaraanListID dari API:",
          data.Data.map((d) => d.KendaraanListID)
        );
      }

      // Set main form values
      const mainValues = {
        BisnisUnitID: data.BisnisUnitID || "",
        Tanggal: data.Tanggal ? new Date(data.Tanggal) : new Date(),
        GeneralServiceUnit: data.GeneralServiceUnit || "",
        Keterangan: data.Keterangan || "",
        KendaraanID: data.KendaraanID || "CS001",
        TKendaraanID: data.TKendaraanID || params.id,
      };

      blastChange(mainValues);

      // Set detail data - PERBAIKAN KRITIS
      if (data.Data && Array.isArray(data.Data)) {
        console.log("======== DETAIL DATA FROM API ========", data.Data);

        const formatTimeForTable = (timeString) => {
          if (!timeString) return "";
          if (typeof timeString === "string" && timeString.includes(":")) {
            const parts = timeString.split(":");
            if (parts.length >= 2) {
              return `${parts[0].padStart(2, "0")}:${parts[1].padStart(
                2,
                "0"
              )}`;
            }
          }
          return "";
        };

        const formattedDetail = data.Data.map((item, index) => {
          console.log(
            `Item ${index} - KendaraanListID: "${item.KendaraanListID}"`
          );

          // PERHATIAN: Simpan KendaraanListID dengan TIDAK mengubahnya ke "0"!
          return {
            KendaraanListID: String(item.KendaraanListID || ""), // JANGAN "0"!
            Nik: item.Nik || "",
            Nama: item.Nama || "",
            ActivityID: item.ActivityID || "",
            ActivityNama: "", // Akan diisi nanti
            JenisPetugas: item.JenisPetugas || "",
            HasilKerja: item.HasilKerja || "",
            Satuan: item.Satuan || "",
            JamAwal: formatTimeForTable(item.JamAwal),
            JamAkhir: formatTimeForTable(item.JamAkhir),
            KMHMAwal: item.KMHMAwal || "",
            KMHMAkhir: item.KMHMAkhir || "",
            BBM: item.BBM || "",
            KeteranganDetail: item.Keterangan || "",
          };
        });

        console.log("======== FINAL DETAIL ========", formattedDetail);
        console.log(
          "KendaraanListID yang disimpan:",
          formattedDetail.map((d) => d.KendaraanListID)
        );

        setDetail(formattedDetail);
      }

      setIsLoading(false);
    }
  }, [mutationGet.data]);

  // Update ActivityNama ketika activityList berubah
  useEffect(() => {
    if (activityList.length > 0 && detail.length > 0) {
      console.log("Updating ActivityNama with loaded activityList...");

      const updatedDetail = detail.map((item) => {
        if (item.ActivityID) {
          const activity = activityList.find(
            (a) => a.value === item.ActivityID
          );
          const newActivityNama = activity?.label || item.ActivityID;

          // Hanya update jika berbeda
          if (newActivityNama !== item.ActivityNama) {
            console.log(
              `Updating ActivityNama for ${item.ActivityID}: ${item.ActivityNama} -> ${newActivityNama}`
            );
            return {
              ...item,
              ActivityNama: newActivityNama,
            };
          }
        }
        return item;
      });

      // Update state hanya jika ada perubahan
      const hasChanges =
        JSON.stringify(updatedDetail) !== JSON.stringify(detail);
      if (hasChanges) {
        console.log("Updated detail with ActivityNama:", updatedDetail);
        setDetail(updatedDetail);
      }
    }
  }, [activityList, detail]);

  useEffect(() => {
    console.log("Current detail state:", detail);
    console.log(
      "KendaraanListID in detail:",
      detail.map((d) => d.KendaraanListID)
    );
  }, [detail]);
  const timeStringToDate = (timeString) => {
    if (!timeString || typeof timeString !== "string") return null;

    const parts = timeString.split(":");
    if (parts.length < 2) return null;

    const hours = Number(parts[0]);
    const minutes = Number(parts[1]);

    if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;

    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
  };

  const dateToTimeString = (date) => {
    if (!(date instanceof Date) || isNaN(date)) return "";

    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  };

  const ModalEdit = (detailRow, id) => {
    console.log("======== MODAL EDIT CALLED ========");
    console.log(`Editing row ${id}:`, detailRow);
    console.log("KendaraanListID from detailRow:", detailRow.KendaraanListID);

    // Debug activityList
    console.log("Available activities:", activityList.length);

    // Cari ActivityNama
    let activityNama = detailRow.ActivityNama || "";
    if (!activityNama && detailRow.ActivityID && activityList.length > 0) {
      const activity = activityList.find(
        (a) => a.value === detailRow.ActivityID
      );
      activityNama = activity?.label || detailRow.ActivityID;
      console.log(`Found ActivityNama: ${activityNama}`);
    }

    // PERBAIKAN: Gunakan KendaraanListID yang sebenarnya
    const modalData = {
      KendaraanListID: String(detailRow.KendaraanListID || ""), // JANGAN "0" jika ada nilainya
      Nik: String(detailRow.Nik || ""),
      Nama: String(detailRow.Nama || ""),
      ActivityID: String(detailRow.ActivityID || ""),
      ActivityNama: String(activityNama || ""),
      JenisPetugas: String(detailRow.JenisPetugas || ""),
      HasilKerja: String(detailRow.HasilKerja || ""),
      Satuan: String(detailRow.Satuan || ""),
      JamAwal: timeStringToDate(detailRow.JamAwal),
      JamAkhir: timeStringToDate(detailRow.JamAkhir),
      KMHMAwal: String(detailRow.KMHMAwal || ""),
      KMHMAkhir: String(detailRow.KMHMAkhir || ""),
      BBM: String(detailRow.BBM || ""),
      KeteranganDetail: String(detailRow.KeteranganDetail || ""),
    };

    console.log("Modal data prepared:", modalData);
    console.log("KendaraanListID in modal:", modalData.KendaraanListID);

    setModalID(id);
    setModalDetail(modalData);
    setShowModal(true);
    setShowModalEdit(true);
  };

  const ModalDelete = (id) => {
    if (window.confirm("Apakah Anda yakin ingin menghapus data ini?")) {
      const newDetail = [...detail];
      newDetail.splice(id, 1);
      setDetail(newDetail);
    }
  };

  const header = [
    { name: "Nik", key: "Nik", modifiers: "text" },
    { name: "Nama", key: "Nama", modifiers: "text" },
    { name: "Activity", key: "ActivityNama", modifiers: "text" },
    { name: "Hasil Kerja", key: "HasilKerja", modifiers: "text" },
    { name: "Satuan", key: "Satuan", modifiers: "text" },
    { name: "Jam Awal", key: "JamAwal", modifiers: "timeonly" },
    { name: "Jam Akhir", key: "JamAkhir", modifiers: "timeonly" },
    { name: "KMHM Awal", key: "KMHMAwal", modifiers: "text" },
    { name: "KMHM Akhir", key: "KMHMAkhir", modifiers: "text" },
    { name: "BBM", key: "BBM", modifiers: "text" },
    { name: "Keterangan", key: "KeteranganDetail", modifiers: "text" },
    { name: "Aksi", key: "EditDelete", modifiers: "EditDelete" },
  ];

  const modalHandler = (value, names) => {
    console.log(`modalHandler: ${names} = ${value}`);
    const newValues = { ...modalDetail, [names]: value };
    setModalDetail(newValues);
  };

  const HandlerKaryawan = (value, names, label) => {
    console.log(`HandlerKaryawan: value=${value}, label=${label}`);

    let nik = value || "0"; // Default ke "0" jika kosong
    let nama = "";

    if (label && label.includes(" - ")) {
      const parts = label.split(" - ");
      if (parts.length >= 2) {
        nama = parts[1].trim();
      }
    }

    if (!nama && karyawanList.length > 0) {
      const karyawan = karyawanList.find((k) => k.value === value);
      if (karyawan?.label?.includes(" - ")) {
        const parts = karyawan.label.split(" - ");
        nama = parts[1]?.trim() || "";
      }
    }

    if (!nama && nik !== "0") {
      nama = `Karyawan ${nik}`;
    }

    const newValues = {
      ...modalDetail,
      [names]: nik,
      Nama: nama,
    };

    console.log("HandlerKaryawan result:", newValues);
    setModalDetail(newValues);
  };

  const HandlerActivity = (value, names, label) => {
    console.log(`HandlerActivity called: value=${value}, label=${label}`);

    // Jika label tidak diberikan, cari dari activityList
    let activityLabel = label;
    if (!activityLabel && value && activityList.length > 0) {
      const activity = activityList.find((a) => a.value === value);
      activityLabel = activity?.label || "";
      console.log(`Found label from list: ${activityLabel}`);
    }

    const newValues = {
      ...modalDetail,
      [names]: value,
      ActivityNama: activityLabel,
    };

    console.log("New modal values after activity change:", newValues);
    setModalDetail(newValues);
  };

  const modalHandlerText = (event) => {
    console.log(
      `modalHandlerText: ${event.target.name} = ${event.target.value}`
    );
    const newValues = {
      ...modalDetail,
      [event.target.name]: event.target.value,
    };
    setModalDetail(newValues);
  };

  const modalHandlerTime = (value, name) => {
    console.log(`Time handler: ${name} = ${value}`);

    // Validasi value sebelum disimpan
    let validatedValue = value;

    if (value && typeof value === "string") {
      // Pastikan format HH:MM
      const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
      if (!timeRegex.test(value)) {
        console.warn(`Invalid time format: ${value}`);
        // Coba format ulang
        if (value.includes(":")) {
          const parts = value.split(":");
          if (parts.length >= 2) {
            const hours = parts[0].padStart(2, "0");
            const minutes = parts[1].padStart(2, "0").substring(0, 2);
            validatedValue = `${hours}:${minutes}`;
          }
        }
      }
    }

    const newValues = {
      ...modalDetail,
      [name]: validatedValue,
    };

    console.log(`Updated ${name} to: ${validatedValue}`);
    setModalDetail(newValues);
  };

  const inputBuilder = [
    {
      type: "karyawan",
      name: "Nik",
      title: "Karyawan",
      handler: HandlerKaryawan,
      size: "full",
      required: true,
      disabled: false,
      edit: false,
    },
    {
      type: "JenisPetugas",
      name: "JenisPetugas",
      title: "Jenis Petugas",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "activity",
      name: "ActivityID",
      title: "Activity",
      handler: HandlerActivity,
      size: "full",
      required: true,
      disabled: false,
      edit: false,
    },
    {
      type: "SatuanKendaraan",
      name: "Satuan",
      title: "Satuan",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "time",
      name: "JamAwal",
      title: "Jam Awal",
      handler: (value) => modalHandlerTime(value, "JamAwal"),
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "time",
      name: "JamAkhir",
      title: "Jam Akhir",
      handler: (value) => modalHandlerTime(value, "JamAkhir"),
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "text", // UBAH DARI "number" KE "text"
      name: "KMHMAwal",
      title: "KMHM Awal",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "text", // UBAH DARI "number" KE "text"
      name: "KMHMAkhir",
      title: "KMHM Akhir",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "text", // UBAH DARI "number" KE "text"
      name: "BBM",
      title: "BBM",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "text", // UBAH DARI "number" KE "text"
      name: "HasilKerja",
      title: "Hasil Kerja",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "text",
      name: "KeteranganDetail",
      title: "Keterangan",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
  ];

  const Kirim = () => {
    let newValues = { ...values };

    if (params.id) {
      newValues["TKendaraanID"] = params.id;
    }

    // Format tanggal
    if (newValues["Tanggal"] instanceof Date) {
      const year = newValues["Tanggal"].getFullYear();
      const month = String(newValues["Tanggal"].getMonth() + 1).padStart(
        2,
        "0"
      );
      const day = String(newValues["Tanggal"].getDate()).padStart(2, "0");
      newValues["Tanggal"] = `${year}-${month}-${day}`;
    }

    // DEBUG DETAILED
    console.log("===== CURRENT DETAIL STATE BEFORE PROCESSING =====");
    detail.forEach((item, index) => {
      console.log(`Detail ${index}:`, {
        KendaraanListID: item.KendaraanListID,
        Nik: item.Nik,
        ActivityID: item.ActivityID,
      });
    });

    const validatedDetail = detail
      .filter((item) => {
        return item && (item.Nik || item.ActivityID);
      })
      .map((item, index) => {
        console.log(
          `Processing detail ${index}: KendaraanListID = "${item.KendaraanListID}"`
        );

        // PERBAIKAN: Gunakan KendaraanListID yang ada, bukan default "0"
        const kendaraanListID =
          item.KendaraanListID && item.KendaraanListID !== ""
            ? String(item.KendaraanListID)
            : "0"; // Hanya "0" jika benar-benar kosong

        return {
          KendaraanListID: kendaraanListID,
          JenisPetugas: String(item.JenisPetugas || ""),
          Nik: item.Nik || "0",
          Nama: String(item.Nama || ""),
          ActivityID: String(item.ActivityID || ""),
          HasilKerja: String(item.HasilKerja || "0"),
          Satuan: String(item.Satuan || ""),
          JamAwal: item.JamAwal ? `${item.JamAwal}:00` : "00:00:00",
          JamAkhir: item.JamAkhir ? `${item.JamAkhir}:00` : "00:00:00",
          KMHMAwal: String(item.KMHMAwal || "0"),
          KMHMAkhir: String(item.KMHMAkhir || "0"),
          BBM: String(item.BBM || "0"),
          Keterangan: String(item.KeteranganDetail || item.Keterangan || ""),
        };
      });

    console.log("===== FINAL PAYLOAD =====");
    validatedDetail.forEach((item, index) => {
      console.log(`Item ${index}: KendaraanListID="${item.KendaraanListID}"`);
    });

    newValues["Data"] = validatedDetail;
    newValues["Status"] = "1";
    newValues["KendaraanID"] = values.KendaraanID || "CS001";

    console.log("FULL PAYLOAD TO SEND:", JSON.stringify(newValues, null, 2));

    if (params.id) {
      console.log("Mengirim UPDATE request...");
      mutationUpdate.mutate(newValues);
    } else {
      console.log("Mengirim ADD request...");
      mutationAdd.mutate(newValues);
    }
  };

  // Effect untuk handling response
  useEffect(() => {
    if (mutationAdd.isSuccess) {
      console.log("Data berhasil ditambahkan:", mutationAdd.data);
      navigate("/equipment/kendaraan");
    }

    if (mutationUpdate.isSuccess) {
      console.log("Data berhasil diupdate:", mutationUpdate.data);
      navigate("/equipment/kendaraan");
    }

    if (mutationGet.isError) {
      console.error("Error loading data:", mutationGet.error);
      setIsLoading(false);
    }
  }, [mutationAdd.status, mutationUpdate.status, mutationGet.status]);

  if (isLoading) {
    return (
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>
        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                <div className="flex flex-col mt-5 items-center justify-center p-8">
                  <div className="text-center">
                    <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-main-100"></div>
                    <p className="mt-4 text-gray-600">Memuat data...</p>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() => navigate("/equipment/kendaraan")}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>

                  <button
                    onClick={Kirim}
                    disabled={mutationAdd.isLoading || mutationUpdate.isLoading}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded disabled:opacity-50"
                  >
                    {mutationAdd.isLoading || mutationUpdate.isLoading ? (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentColor"
                          />
                        </svg>
                        Loading...
                      </>
                    ) : (
                      "Simpan"
                    )}
                  </button>
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"BisnisUnit"}
                    value={values}
                    name={"BisnisUnitID"}
                    title={"Bisnis Unit"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={!!params.id}
                  />
                </div>
                {values["BisnisUnitID"] && (
                  <>
                    <div className="w-1/3">
                      <HrdInputGenerator
                        type={"dateOnly"}
                        value={values}
                        name={"Tanggal"}
                        title={"Tanggal"}
                        onChange={customHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={false}
                      />
                    </div>
                    <div className="w-1/3">
                      <HrdInputGenerator
                        type={"GeneralServiceUnit"}
                        value={values}
                        name={"GeneralServiceUnit"}
                        title={"Kode Kenderaan"}
                        onChange={customHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={false}
                      />
                    </div>
                    <div className="w-1/3">
                      <HrdInputGenerator
                        type={"text"}
                        value={values}
                        name={"Keterangan"}
                        title={"Keterangan"}
                        onChange={changeHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={false}
                      />
                    </div>
                  </>
                )}
                <hr />

                <DynamicTableSimpleCustom
                  data={detail}
                  header={header}
                  Master={true}
                  OnClick={ModalOpener} // <-- PERBAIKAN DI SINI
                  edit={(row, index) => {
                    console.log("Table edit clicked - Row:", row);
                    console.log(
                      "Table edit clicked - KendaraanListID:",
                      row.KendaraanListID
                    );
                    ModalEdit(row, index);
                  }}
                  delete={ModalDelete}
                />
              </div>
            </Card>

            {/* Modal untuk tambah/edit detail */}

            <Modal
              key={showModalEdit ? `edit-${modalID}` : "add"}
              size="lg"
              active={showModal}
              toggler={() => {
                console.log("Modal toggler called");
                setShowModal(false);
                setShowModalEdit(false);
                setModalDetail(initialStateModal);
              }}
            >
              <ModalHeader
                toggler={() => {
                  setShowModal(false);
                  setShowModalEdit(false);
                  setModalDetail(initialStateModal);
                }}
              >
                {showModalEdit ? "Edit Data" : "Tambah Data"}
              </ModalHeader>
              <ModalBody>
                <form className="w-full">
                  {/* Debug info */}
                  <div style={{ display: "none" }}>
                    {console.log("Modal detail rendered:", modalDetail)}
                    {console.log("Show modal edit:", showModalEdit)}
                    {JSON.stringify(modalDetail)}
                  </div>

                  {/* Debug panel */}
                  {/* {showModalEdit && (
                    <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded">
                      <h4 className="font-bold text-yellow-800">Debug Info:</h4>
                      <pre className="text-xs overflow-auto">
                        {JSON.stringify(modalDetail, null, 2)}
                      </pre>
                    </div>
                  )} */}

                  {inputBuilder.map((item, id) => {
                    // Untuk dropdown activity, tambahkan loading state
                    if (item.type === "activity" && activityList.length === 0) {
                      return (
                        <div key={id} className="mb-4">
                          <label className="block text-gray-700 text-sm font-bold mb-2">
                            {item.title}
                          </label>
                          <div className="text-gray-500">
                            Loading activities...
                          </div>
                        </div>
                      );
                    }

                    if (item.type === "karyawan" && karyawanList.length === 0) {
                      return (
                        <div key={id} className="mb-4">
                          <label className="block text-gray-700 text-sm font-bold mb-2">
                            {item.title}
                          </label>
                          <div className="text-gray-500">
                            Loading karyawan...
                          </div>
                        </div>
                      );
                    }

                    return (
                      <HrdInputGenerator
                        key={id}
                        type={item.type}
                        value={modalDetail}
                        name={item.name}
                        title={item.title}
                        onChange={item.handler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={item.size}
                        required={item.required}
                        errors={errors}
                        disabled={item.disabled}
                      />
                    );
                  })}
                </form>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="red"
                  buttonType="link"
                  onClick={() => {
                    setShowModal(false);
                    setShowModalEdit(false);
                    setModalDetail(initialStateModal);
                  }}
                  ripple="dark"
                >
                  Cancel
                </Button>

                <Button
                  color="green"
                  onClick={() => {
                    console.log("Saving modal data:", modalDetail);

                    if (!modalDetail.Nik || !modalDetail.ActivityID) {
                      alert("Data Karyawan dan Activity wajib diisi!");
                      return;
                    }

                    // Helper untuk format numerik
                    const formatNumeric = (val) => {
                      if (!val && val !== 0) return "0";
                      return String(val);
                    };

                    // ==================== PERBAIKAN DI SINI ====================
                    const detailToAdd = {
                      // PASTIKAN KendaraanListID disertakan!
                      KendaraanListID: String(
                        modalDetail.KendaraanListID || "0"
                      ), // INI YANG HILANG
                      Nik: modalDetail.Nik || "0",
                      Nama: String(modalDetail.Nama || ""),
                      ActivityID: String(modalDetail.ActivityID || ""),
                      ActivityNama: String(modalDetail.ActivityNama || ""),
                      JenisPetugas: String(modalDetail.JenisPetugas || ""),
                      HasilKerja: formatNumeric(modalDetail.HasilKerja),
                      Satuan: String(modalDetail.Satuan || ""),
                      JamAwal: modalDetail.JamAwal
                        ? dateToTimeString(modalDetail.JamAwal)
                        : "",
                      JamAkhir: modalDetail.JamAkhir
                        ? dateToTimeString(modalDetail.JamAkhir)
                        : "",
                      KMHMAwal: formatNumeric(modalDetail.KMHMAwal),
                      KMHMAkhir: formatNumeric(modalDetail.KMHMAkhir),
                      BBM: formatNumeric(modalDetail.BBM),
                      KeteranganDetail: String(
                        modalDetail.KeteranganDetail || ""
                      ),
                    };

                    console.log("Detail to add/update:", detailToAdd);
                    console.log(
                      "KendaraanListID in detailToAdd:",
                      detailToAdd.KendaraanListID
                    );

                    if (showModalEdit) {
                      const newValues = [...detail];
                      newValues[modalID] = detailToAdd; // INI AKAN OVERWRITE DATA LAMA
                      console.log("Updated detail:", newValues);
                      setDetail(newValues);
                    } else {
                      const newValues = [...detail, detailToAdd];
                      console.log("Added new detail:", newValues);
                      setDetail(newValues);
                    }

                    setModalDetail(initialStateModal);
                    setShowModal(false);
                    setShowModalEdit(false);
                  }}
                  ripple="light"
                >
                  {showModalEdit ? "Ubah" : "Tambah"}
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateKendaraanPage;
